import { locationIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const CrdbLocationSchema = z.object({
  id: locationIdFormat.schema,
  name: z.string(),
  externalId: z.string().nullish(),
});

export type CrdbLocation = z.infer<typeof CrdbLocationSchema>;

export const getCrdbLocations = {
  name: "getCrdbLocations" as const,
  input: z
    .object({ onlyWithWarehouseLayout: z.boolean().optional() })
    .nullable(),
  output: z.object({ locations: z.array(CrdbLocationSchema) }),
};
